<div class="admin-update-preview-data">
  <div class="header">
    <div>
      <span>Admin Data Preview</span>
    </div>
    <button
      mat-icon-button
      class="close-button"
      (click)="onCloseClick()"
      disableRipple
    >
      <mat-icon class="close-icon">close</mat-icon>
    </button>
  </div>
  <div class="content">
    <div class="table-container">
      <table mat-table [dataSource]="adminData" class="mat-elevation-z8">
        <ng-container *ngFor="let column of displayedColumns">
          <ng-container matColumnDef="{{ column }}">
            <th mat-header-cell *matHeaderCellDef>{{ column | titlecase }}</th>
            <td  style="border-bottom: 1px solid rgb(184, 181, 181);" mat-cell *matCellDef="let element">{{ element[column] }}</td>
          </ng-container>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
